import { put } from 'redux-saga/effects';

export function loaderDecorator(targetFunction, loader) {
    return function*() {
        yield put(loader(true));
        try {
            yield targetFunction.apply(this, arguments);
        } finally {
            yield put(loader(false));
        }
  };
}


// WEBPACK FOOTER //
// ./src/sagas/decorators/loader-decorator.js